// extracted by mini-css-extract-plugin
module.exports = {"customHero":"Features_customHero_jOQMR","heroImg":"Features_heroImg_2Y2kA"};